import registry from "./registry"

export default (name: keyof typeof registry, func: () => void) =>
  registry[name]().then(func)
